//Pages
import ComponentsPage from './pages/components-page'
import ComponentsPost from './pages/components-post'

export default class AppPages {
    constructor() {
        const ComponentsPageElement = document.querySelector('.components-page')
        const ComponentsPostElement = document.querySelector('.content-post')

        ComponentsPageElement ? new ComponentsPage() : null
        ComponentsPostElement ? new ComponentsPost() : null
    }
}

new AppPages()